import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import axios from 'axios';
import t, { LANGUAGES } from '../i18n/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // localStorage'dan veya site ayarlarından dil al
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem('site-language');
    if (saved && LANGUAGES[saved]) return saved;
    return 'tr'; // geçici default, site-settings'den güncellenecek
  });

  const [defaultLang, setDefaultLang] = useState('tr');

  // Site varsayılan dilini backend'den çek (sadece localStorage'da kayıt yoksa uygula)
  useEffect(() => {
    axios.get('/api/site-settings').then(({ data }) => {
      const siteLang = data.site_language;
      if (siteLang && LANGUAGES[siteLang]) {
        setDefaultLang(siteLang);
        // Kullanıcı daha önce dil seçmediyse site default'unu kullan
        const saved = localStorage.getItem('site-language');
        if (!saved) {
          setLangState(siteLang);
        }
      }
    }).catch(() => {});
  }, []);

  // Dil değişince HTML dir ve lang attribute'larını güncelle
  useEffect(() => {
    const dir = LANGUAGES[lang]?.dir || 'ltr';
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('dir', dir);
    // RTL için body sınıfı
    if (dir === 'rtl') {
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
    }
  }, [lang]);

  const setLang = useCallback((newLang) => {
    if (!LANGUAGES[newLang]) return;
    localStorage.setItem('site-language', newLang);
    setLangState(newLang);
  }, []);

  // Çeviri fonksiyonu: t('nav.home') → 'Home'
  const tr = useCallback((key) => {
    const parts = key.split('.');
    let val = t[lang];
    for (const part of parts) {
      if (val && typeof val === 'object') {
        val = val[part];
      } else {
        val = undefined;
        break;
      }
    }
    // Fallback: önce Türkçe, sonra key
    if (val === undefined) {
      let fallback = t['tr'];
      for (const part of parts) {
        if (fallback && typeof fallback === 'object') {
          fallback = fallback[part];
        } else {
          fallback = undefined;
          break;
        }
      }
      return fallback || key;
    }
    return val;
  }, [lang]);

  const isRTL = LANGUAGES[lang]?.dir === 'rtl';

  return (
    <LanguageContext.Provider value={{ lang, setLang, tr, isRTL, defaultLang, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
